import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { useLanguage } from '../contexts/LanguageContext';

const TEAM_MEMBERS = [
  { name: 'Paul Schneider', position: 'Management', photo: '/PaulImage.jpeg' },
  { name: 'Paul Kleiber', position: 'Management', photo: '/PeopleImages/PaulKleiberImage.jpeg' },
  { name: 'Fabienne Reimers', position: 'Head of Digitalisierung', photo: '/PeopleImages/FabieneImage.jpeg' },
  { name: 'Daniel Gerber', position: 'Head of AI CV Matching', photo: '/PeopleImages/Daniel.jpeg' },
  { name: 'Anesa Hasanovic', position: 'Head of Marketing', photo: '/PeopleImages/AnesaImage.jpeg' },
  { name: 'Emilia Rau', position: 'Head of Marketing', photo: '/PeopleImages/EmiliaImage.jpeg' },
  { name: 'Julia Schikorra', position: 'Marketing', photo: '/PeopleImages/JuliaImage.jpeg' },
  { name: 'Marlene Dökel', position: 'Marketing', photo: '/PeopleImages/MarleneImage.jpeg' },
  { name: 'Joris Schleer', position: 'Head of Sponsoring', photo: '/PeopleImages/JorisImage.jpeg' },
  { name: 'Marvin Zaiss', position: 'Head of Sponsoring', photo: '/PeopleImages/MarvinImage.jpeg' },
  { name: 'Daniel Cremer', position: 'Sponsoring', photo: '/PeopleImages/DanielCremerImage.jpeg' },
  { name: 'Emma Loewenhaupt', position: 'Head of University Contacts', photo: '/PeopleImages/EmmaImage.jpeg' },
  { name: 'Raissa Fru', position: 'Head of University Contacts', photo: '/PeopleImages/Raissa.jpeg' },
  { name: 'Kilian Rao', position: 'Head of Finance', photo: '/PeopleImages/KilianImage.jpeg' },
  { name: 'Rico Moll', position: 'Head of Sports', photo: '/PeopleImages/RicoImage.jpeg' },
  { name: 'Henrik Hornung', position: 'Sports', photo: '/PeopleImages/HenrikImage.jpeg' },
  { name: 'Marc Trösser', position: 'Sports', photo: '/PeopleImages/MarcTrösser.jpeg' },
];

export const Team = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-28 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="text-ngbc-primary hover:text-ngbc-accent font-medium mb-8 flex items-center gap-1"
          >
            ← {t('team.teamZurueck')}
          </button>
          <h1 className="text-4xl font-bold text-neutral-900 mb-2">
            {t('team.orgTeamTitle')}
          </h1>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-x-6 gap-y-10">
            {TEAM_MEMBERS.map((member, idx) => (
              <article key={idx} className="text-left">
                <div className="w-full aspect-[3/4] bg-neutral-100 overflow-hidden">
                  {member.photo ? (
                    <img
                      src={member.photo}
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full bg-neutral-200 flex items-center justify-center">
                      <span className="text-neutral-400 text-3xl font-bold">
                        {member.name
                          .split(' ')
                          .map((n) => n[0])
                          .join('')}
                      </span>
                    </div>
                  )}
                </div>
                <p className="mt-3 font-bold text-neutral-900 text-base leading-snug">
                  {member.name}
                </p>
                <p className="mt-0.5 text-sm text-neutral-500 leading-snug">
                  {member.position}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
